import { render, staticRenderFns } from "./Locus.vue?vue&type=template&id=659325bb&"
import script from "./Locus.vue?vue&type=script&lang=js&"
export * from "./Locus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Locus.vue"
export default component.exports